
import { createRouter, createWebHistory } from 'vue-router';
import emitter from '@/eventBus.js';
import LoginPage from '@/components/pages/LoginPage.vue';
import HomePage from '@/components/pages/HomePage.vue';
import AccountPage from '@/components/pages/AccountPage.vue';

const routes = [
  {
    path: '/',
    component: HomePage,
  },
  {
    path: '/login',
    component: LoginPage,
  },
  {
    path: '/account',
    component: AccountPage,
    children: [
      {
        path: '',
        redirect: '/account/profile',
      },
      {
        path: 'profile',
        component: () => import('@/components/blocks/AccountSpecialistProfile.vue'),
      },
      {
        path: 'view',
        component: () => import('@/components/blocks/UserStage3.vue'),
      },
      {
        path: 'company',
        component: () => import('@/components/blocks/UserStage4.vue'),
      },
      {
        path: 'transfer',
        component: () => import('@/components/blocks/UserStage5.vue'),
      },
      {
        path: 'vacancy',
        component: () => import('@/components/blocks/VacanciesList.vue'),
      },
      {
        path: 'studentsList',
        component: () => import('@/components/blocks/SchoolStageStudentsList.vue'),
      },
      {
        path: 'profile',
        component: () => import('@/components/blocks/SchoolStageInfo.vue'),
      },
      {
        path: 'teachersSchool',
        component: () => import('@/components/blocks/TeachersSchool.vue'),
      },
      {
        path: 'billingSchool',
        component: () => import('@/components/blocks/StageFinance.vue'),
      },
      {
        path: 'accountSetting',
        component: () => import('@/components/blocks/AccountSetting.vue'),
      },
      {
        path: 'stepByStep',
        component: () => import('@/components/blocks/StepByStep.vue'),
      },
      {
        path: 'landing',
        component: () => import('@/components/blocks/SchoolLanding.vue'),
      },
      {
        path: 'universitySetting/:id',
        component: () => import('@/components/blocks/school/SchoolSetting.vue'),
      },
      {
        path: 'companySetting/:id',
        component: () => import('@/components/blocks/company/CompanySetting.vue'),
      },
      {
        path: 'school/:id',
        component: () => import('@/components/blocks/SchoolStageInfo.vue'),
      },
      {
        path: 'university/:id',
        component: () => import('@/components/blocks/university/UniversityStageInfo.vue'),
      },
      {
        path: 'company/:id',
        component: () => import('@/components/blocks/company/CompanyStageInfo.vue'),
      },
      {
        path: 'company/:id/addVacancy',
        component: () => import('@/components/blocks/company/AddVacancy.vue'),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
  }
});

router.beforeEach((to, from, next) => {
  emitter.emit('show-preloader');
  next();
});

router.afterEach(() => {
  // Вызываем событие скрытия прелоудера
  emitter.emit('hide-preloader');
});
export default router;
